function isEnabled(value: string | undefined): boolean {
  if (value === undefined || value === "") return true;
  return value.toLowerCase() === "true" || value === "1";
}

export const featureFlags = {
  maintenance: isEnabled(import.meta.env.VITE_FEATURE_MAINTENANCE),
  schadenKI: isEnabled(import.meta.env.VITE_FEATURE_SCHADENKI),
  analytics: isEnabled(import.meta.env.VITE_FEATURE_ANALYTICS),
  blockbrain: isEnabled(import.meta.env.VITE_FEATURE_BLOCKBRAIN),
} as const;
